import { emsApi } from '@/api/emsApi';
import type { EmsComponents } from '@ngsos/portal-core/api/ems';

export type IncidentListItem =
  EmsComponents['schemas']['NG_SOS.Incidents.Domain.Abstractions.IncidentListItem'];
export type FilterIncidentsBody =
  EmsComponents['schemas']['NG_SOS.EMS.Api.Abstractions.Portal.v1.FilterIncidentsBody'];

export async function getIncidents(body: FilterIncidentsBody): Promise<IncidentListItem[]> {
  const { data, response } = await emsApi.POST('/portal/v1/incidents', { body });
  if (data === undefined) {
    throw new Error(`Failed to load incidents (HTTP ${response.status})`);
  }
  return data;
}
